module.exports = __webpack_public_path__ + "assets/img/img-course3.790682bd.png";